import { Container } from '@/components/shared/container'
import { SectionHeader } from '@/components/shared/section-header'
import { BlokProps } from '@/lib/types'
import { PageHeaderStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'

export function PageHeader({ blok }: BlokProps<PageHeaderStoryblok>) {
  return (
    <div
      className="from-background to-sidebar bg-gradient-to-b py-16"
      {...storyblokEditable(blok)}
    >
      <Container>
        <SectionHeader
          title={blok.title}
          icon={blok.descriptorIcon}
          preTitle={blok.descriptorTitle}
          content={blok.content}
        />
      </Container>
    </div>
  )
}
